export default __webpack_public_path__ + "static/media/mindmap_tsa.a81e9022.jpg";